export const settingsTableHeader = [
  { title: 'Name', key: 'text' },
  { title: 'Created By', key: 'userName' },
  { title: 'Created on', key: 'createdOn', flag: 'dateTime' },
];

export const fieldOfInterestTableHeader = [
  { title: 'Name', key: 'text' },
  { title: 'Brochure URL Link', key: 'brochureLink', flag: 'link' },
  { title: 'Application Type', key: 'applicationsCS', flag: 'appType' },
  { title: 'Created By', key: 'userName' },
  { title: 'Created on', key: 'createdOn', flag: 'dateTime' },
];
export const academicYearTableHeader = [
  { title: 'Name', key: 'academicName' },
  { title: 'Start Date', key: 'startDate', flag: 'date' },
  { title: 'End Date', key: 'endDate', flag: 'date' },
  { title: 'Active', key: 'active', flag: 'bolean' },
  { title: 'Created By', key: 'log', secondKey: 'createdByUser', hide: true },
  {
    title: 'Created on',
    key: 'log',
    secondKey: 'createdOn',
    flag: 'dateTime',
    hide: true,
  },
];

export const externalContactsTableHeader = [
  { title: 'Name', key: 'contactName' },
  { title: 'Email', key: 'email' },
  { title: 'Mobile', key: 'mobile' },
  { title: 'Contact Type', key: 'contactType_Display' },
  { title: 'Priority', key: 'priority_Display' },
  { title: 'Country', key: 'country_Display' },
  { title: 'Curriculum', key: 'curriculum_Display' },
  { title: 'Grade', key: 'grade_Display' },
  { title: 'Job Title', key: 'jobTitle' },
  { title: 'Nationality', key: 'nationality_Display' },
  { title: 'School', key: 'schoolName' },
  { title: 'User Assigned', key: 'userAssigned' },
  {
    title: 'Last Email Received On',
    key: 'lastEmailReceivedOnDisplay',
  },
  { title: 'Created On', key: 'createdOnDisplay' },
];
export const eSignatureHeader = [
  { title: 'Name', key: 'signatureName' },
  { title: 'Created By', key: 'log', secondKey: 'createdByUser', hide: true },
  {
    title: 'Created on',
    key: 'log',
    secondKey: 'createdOn',
    flag: 'dateTime',
    hide: true,
  },
];
